export default __webpack_public_path__ + "static/media/myimg.5c5de6e6.jpg";